import { render, staticRenderFns } from "./new-connection-form.vue?vue&type=template&id=2c8f883c&"
import script from "./new-connection-form.vue?vue&type=script&lang=js&"
export * from "./new-connection-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports